export default __webpack_public_path__ + "static/media/wiki.6c0bae6c.jpg";